<template>
  <div class="components-dialog">
    <a-modal
      :width="900"
      :title="form.id ? $t('update') : $t('create')"
      :visible="dialog"
      :maskClosable="false"
      @cancel="cancel"
    >
      <template slot="footer">
        <a-button key="back" @click="cancel"> 取消 </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="confirm"
        >
          提交
        </a-button>
      </template>
      <a-form-model ref="ruleForm" :model="form" :rules="rules">
        <a-form-model-item label="年份" prop="year">
          <a-date-picker
              format="YYYY"
              mode="year"
              :value="form.year"
              :open="open"
              :allowClear="false"
              @openChange="openChange"
              @panelChange="panelChange"
          />
        </a-form-model-item>
        <a-form-model-item label="时间" prop="time">
            <a-range-picker
              format="YYYY-MM-DD"
              :value="form.time"
              @change="onChange"
              :disabled-date="disabledDate"
            />
          </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea
            v-model="form.remark"
            :rows="4"
            placeholder="请输入备注"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<style lang="less">
.item.row .ant-form-item {
  width: 100%;
}
.item {
  display: flex;
  .ant-form-item {
    width: 50%;
    display: flex;
    .ant-form-item-label {
      width: 90px;
      text-align: right;
    }
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .ant-checkbox-wrapper {
    width: 50%;
    margin: 0;
  }
}
</style>
<script>
import moment from 'moment';
import {
  ShiftOffDayServiceProxy,
} from "@/service-proxies/app-v2/time.service-proxies";
const api = new ShiftOffDayServiceProxy();
const options = {
  insert: api.insert.bind(api),
  update: api.update.bind(api)
};
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    form: Object,
  },
  watch: {
    form: {
      handler(obj){
        this.formData = obj;
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      moment,
      rules: {
        year: [{ required: true, message: "请选择年份", trigger: "blur" }],
        time: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
      ...options,
      loading: false,
      open: false,
      formData: {}
    };
  },
  methods: {
    cancel() {
      this.$refs.ruleForm.clearValidate();
      this.$emit("close");
    },
    onChange(date, dateString) {
      this.form.time = dateString;
      this.form.startOffDay = dateString[0];
      this.form.endOffDay = dateString[1];
    },
    confirm() {
      if (this.loading) {
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let method;
          if(this.formData.id) {
            method = this.update;
          } else {
            method = this.insert;
          }
          const p = {...this.formData, ...{year: this.formData.year.format('YYYY')}}
          method(p).then(_ => {
            this.$emit('update');
            this.loading = false;
          }).catch(_=>{
            this.loading = false;
          });
        }
      });
    },

    // time
    disabledDate(showTime) {
      var timeYear = showTime.get('year');  // 当前年
      return timeYear != this.form.year.format('YYYY'); //  不等于选中年度
    },
    openChange(status) {
      if (status) {
        this.open = true;
      } else {
        this.open = false;
      }
    },
    panelChange(value){
      this.form.year = value;
      this.open = false;
    }
  },
};
</script>
